import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_5 = { class: "relative w-full text-left transition-all transform bg-white rounded shadow sm:my-8 sm:w-full sm:max-w-lg" }
const _hoisted_6 = { class: "bg-white" }
const _hoisted_7 = { class: "flex items-center justify-between border-b border-gray-400" }
const _hoisted_8 = { class: "w-full px-2 py-4 text-left" }
const _hoisted_9 = {
  class: "text-lg font-medium leading-6 text-gray-900",
  id: "modal-title"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onSubmit"]
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "ml-1 text-sm font-semibold capitalize" }
const _hoisted_15 = {
  key: 0,
  class: "absolute left-0 z-50 w-full h-64 overflow-y-scroll bg-white border border-gray-300 rounded top-10"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "flex justify-between" }
const _hoisted_18 = { class: "px-2 text-sm text-white rounded-full bg-success w-fit" }
const _hoisted_19 = {
  key: 0,
  class: "text-sm text-gray-800"
}
const _hoisted_20 = {
  key: 0,
  class: "flex justify-center px-4 py-3 bg-gray-50"
}

import { ref } from "vue";
import { useI18n } from "vue-i18n";

import DefaultButton from "../DefaultButton.vue";

import api from "@/api/api";
import { Club, ClubDate } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'MoveStudentModal.vue',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
  isSaving: {
    type: Boolean,
    required: true,
  },
  organisation: {
    type: Number,
    required: true,
  }
},
  emits: ["close", "move"],
  async setup(__props, { emit: emits }) {

let __temp: any, __restore: any

const props = __props;

const { t } = useI18n();




const showClubList = ref(false);
const hasSelectedClub = ref(false);

const clubs = ref([] as Club[]);
const club = ref({} as Club);

function openClubList() {
  if (!clubs.value.length) return;
  showClubList.value = !showClubList.value;
}

function hasFutureDate(dates: ClubDate[]) {
  const today = new Date();
  const futureDate = dates.find(date => new Date(date.date) > today);
  return futureDate ? new Date(futureDate.date).toLocaleDateString() : "";
}

function hasPlaces(club: Club) {
  const spaces = club.participants_count - club.students.length;

  if (spaces === 1) return `${spaces} ${t("place-available")}`;
  if (spaces > 1) return `${spaces} ${t("places-available")}`;

  return t("no-places-available");
}

function close() {
  showClubList.value = false;
  emits("close");
}

function saveChild() {
  return emits("move", club.value.id);
}

const response = (
  ([__temp,__restore] = _withAsyncContext(() => api.clubs.listClubs({
  page: "all",
  students: true,
  organisation: props.organisation,
}))),
  __temp = await __temp,
  __restore(),
  __temp
);
clubs.value = response.data.clubs ? response.data.clubs : [];

return (_ctx: any,_cache: any) => {
  return (props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("move-club-member")), 1)
                  ]),
                  _createElementVNode("div", { class: "py-4 pl-2 pr-4" }, [
                    _createElementVNode("button", { onClick: close }, _hoisted_11)
                  ])
                ]),
                _createElementVNode("form", {
                  class: "px-4 pb-8 mt-4 border-b border-gray-400",
                  onSubmit: _withModifiers(saveChild, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("brick-club")), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-400 relative", clubs.value.length ? 'hover:cursor-pointer' : '']),
                      onClick: openClubList
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(club.value.name ? 'text-black' : 'text-gray-700')
                      }, _toDisplayString(club.value.name ? club.value.name : clubs.value.length ? _ctx.$t("please-select-a-brick-club") : _ctx.$t("no-brick-clubs-available")), 3),
                      (showClubList.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clubs.value.filter(i => i.places_available), (c, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                onClick: ($event: any) => {
                        club.value = c;
                        hasSelectedClub.value = true;
                      },
                                class: "p-2 hover:bg-gray-200"
                              }, [
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("div", null, _toDisplayString(c.name), 1),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_18, _toDisplayString(hasPlaces(c)), 1)
                                  ])
                                ]),
                                (hasFutureDate(c.dates))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Next session: " + _toDisplayString(hasFutureDate(c.dates)), 1))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_16))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  (clubs.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(DefaultButton, {
                          type: "primary",
                          "is-form-submit": true,
                          disabled: !hasSelectedClub.value,
                          loading: __props.isSaving
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("move-this-child-to-new-club")), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled", "loading"])
                      ]))
                    : _createCommentVNode("", true)
                ], 40, _hoisted_12)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})